import URI from 'urijs';

$(function () {
    window.initPdfViewer();
});

/**
 * Pdf viewer
 */
window.initPdfViewer = function ($object = null) {

    if (null === $object) {
        $object = $('a');
    } else {
        $object = $($object).find('a');
    }

    $object.each(function () {

        const $element = $(this);

        const href = $element.prop('href');
        const uri = URI(href);

        let filename;
        // Check if contao content element download(s). With url = /action?file=path/to/file.pdf&cid=123
        const query = uri.search(true);
        if (query.file) {
            filename = query.file;
        } else {
            filename = uri.filename();
        }

        if (!filename) {
            return;
        }

        // Check if it's a pdf file
        if (!filename.match(/\.pdf$/i)) {
            return;
        }

        // Check if it should be downloadable (if it is a download-element)
        const $downloadElement = $element.closest('.download-element');
        if ($downloadElement.length && $downloadElement.hasClass('allow-download')) {
            return;
        }
        // Target blank is supposed to be downloadable
        if ($element.prop('target') === '_blank') {
            return;
        }

        // Build new viewer link
        const viewerUri = '/pdfjs/web/viewer.html?file=' + encodeURIComponent(uri);

        // Hide href
        $element.prop('href', '');

        // Build modal
        const modalHtml = '<div class="modal" tabindex="-1">\n' +
            '  <div class="modal-dialog modal-xl">\n' +
            '    <div class="modal-content">\n' +
            '      <div class="modal-header">\n' +
            '        <button type="button" class="close p-0" data-dismiss="modal" aria-label="Close">\n' +
            '          <span aria-hidden="true">&times;</span>\n' +
            '        </button>\n' +
            '      </div>\n' +
            '      <div class="modal-body p-0">\n' +
            '          <iframe class="modal-iframe w-100" style="height: calc(100vh - 105px)"></iframe>\n' +
            '      </div>\n' +
            '    </div>\n' +
            '  </div>\n' +
            '</div>';
        const $modal = $(modalHtml);
        const $modalIframe = $modal.find('.modal-iframe');
        $('body').append($modal);

        // Handle click
        $element.on('click', function (event) {
            event.preventDefault();
            $modalIframe.prop('src', viewerUri);
            $modal.modal('show');
        });

    });

};
